import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'viewer-pdf-toolbar',
  templateUrl: './toolbar.component.html',
  host: { 'hostID': crypto.randomUUID().toString() } // evitar aviso "collision ID"
})
export class ViewerPdfToolbarComponent {

  public zoomValue = 100;

  @Input() numPages;
  @Input() page;
  @Input() base64PdfModal;

  @Output() incrementPage = new EventEmitter<number>();
  @Output() incrementZoom = new EventEmitter<number>();

  @Output() viewPages = new EventEmitter<number>();

  onIncrementPage(amount: number) {
    this.incrementPage.emit(amount);
  }

  onIncrementZoom(amount: number) {
    if((this.zoomValue === 500 && amount === 0.1) || (this.zoomValue === 20 && amount === -0.1)){
      return;
    }
    this.incrementZoom.emit(amount);
    this.zoomValue += amount*100;
  }

  showOnePage() {
    this.viewPages.emit(1);
    this.zoomValue = 100;
  }

  showTwoPages() {
    this.viewPages.emit(2);
    this.zoomValue = 80;
  }
}
